import * as React from "react";
import { cn } from "~/lib/utils";
// Inlined (not <img>) so the wordmark's `var(--fill-0)` can take the text color.
import driveLogo from "~/assets/products/drive-logo.svg?raw";
import viewLogo from "~/assets/products/view-logo.svg?raw";
import goLogo from "~/assets/products/go-logo.svg?raw";

const WORDMARK: Record<string, string> = {
  bouncieobd: driveLogo,
  bounciedashcam: viewLogo,
  bounciecharger: goLogo,
};

export function hasProductWordmark(productCode: string) {
  return productCode in WORDMARK;
}

// The product's wordmark SVG in the current text color, sized by `className`'s height.
export function ProductWordmark({ productCode, name, className }: { productCode: string; name: string; className?: string }) {
  return (
    <span
      role="img"
      aria-label={name}
      className={cn("block [&>svg]:h-full [&>svg]:w-auto", className)}
      style={{ "--fill-0": "currentColor" } as React.CSSProperties}
      dangerouslySetInnerHTML={{ __html: WORDMARK[productCode] }}
    />
  );
}
